let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2RnUf")).then(() => parcelRequire('6IFvl'));